import Reflux from 'reflux';

const ExportActions = Reflux.createActions([
  'exportIncomingPayment',
  'exportIncomingPaymentComplete'
]);

export default ExportActions;



// WEBPACK FOOTER //
// ./src/js/actions/Export.js